import React from 'react';

interface IconProps {
  className?: string;
}

/** Red filled circle with a white exclamation mark. Decorative; hidden from assistive technology. */
const ErrorIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
    <circle cx="10" cy="10" r="10" fill="#b3261e" />
    <path d="M10 5v6" stroke="#ffffff" strokeWidth="2" fill="none" />
    <circle cx="10" cy="14.5" r="1.25" fill="#ffffff" />
  </svg>
);

export default ErrorIcon;
